/**
 * Bulk selection helpers for the playlist "Select video source" modal.
 *
 * Dependency-free so the pure-logic spec can import it without alias resolution.
 */

/**
 * How many of `ids` are in `selectedIds`.
 * @param {Array<string>} ids
 * @param {Set<string>} selectedIds
 * @returns {'none' | 'some' | 'all'}
 */
export function selectionState(ids, selectedIds) {
	if (!ids.length) return 'none'
	const count = ids.filter((id) => selectedIds.has(id)).length
	if (count === 0) return 'none'
	return count === ids.length ? 'all' : 'some'
}

/**
 * Add or remove many playlist entries at once.
 * Selecting prepends the missing entries in the given order (newest first, like a
 * single toggle, but without reversing the batch). Unselecting drops entries by id.
 * @param {Array<{id: string}>} items current playlist entries
 * @param {Array<{id: string}>} entries entries to add or remove
 * @param {boolean} select
 * @returns {Array<{id: string}>} a new array
 */
export function applyBulk(items, entries, select) {
	if (select) {
		const present = new Set(items.map((item) => item.id))
		const missing = []
		entries.forEach((entry) => {
			if (present.has(entry.id)) return
			present.add(entry.id)
			missing.push(entry)
		})
		return [...missing, ...items]
	}
	const removeIds = new Set(entries.map((entry) => entry.id))
	return items.filter((item) => !removeIds.has(item.id))
}
